export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9093.c0a79d5c.jpg";